import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { themeTokens, resetStyles } from '../../styles/tokens.css.js';

@customElement('yebo-error-banner')
export class YeboErrorBanner extends LitElement {
  static styles = [
    themeTokens,
    resetStyles,
    css`
      :host {
        display: block;
      }
      .banner {
        padding: var(--yebo-space-sm) var(--yebo-space-md);
        background: rgba(224, 82, 82, 0.25);
        border: 1px solid rgba(224, 82, 82, 0.4);
        border-radius: var(--yebo-radius);
        color: #ff7a7a;
        font-size: var(--yebo-font-size-sm);
        display: flex;
        align-items: center;
        gap: var(--yebo-space-sm);
      }
      .icon {
        flex-shrink: 0;
        font-size: 1.1em;
      }
      .dismiss {
        margin-left: auto;
        background: none;
        border: none;
        color: #ff7a7a;
        cursor: pointer;
        padding: 2px 6px;
        font-size: 1.1em;
        border-radius: 4px;
      }
      .dismiss:hover {
        background: rgba(224, 82, 82, 0.2);
      }
    `,
  ];

  @property({ type: String })
  message = '';

  private _dismiss() {
    this.dispatchEvent(new CustomEvent('dismiss', { bubbles: true, composed: true }));
  }

  render() {
    if (!this.message) return null;

    return html`
      <div class="banner" role="alert" aria-live="polite">
        <span class="icon" aria-hidden="true">!</span>
        <span>${this.message}</span>
        <button class="dismiss" @click=${this._dismiss} aria-label="Dismiss error">&times;</button>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'yebo-error-banner': YeboErrorBanner;
  }
}
